import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1E2A38', // Bleu Nuit Profond
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#D5B97B', // Doré Mat / Champagne
      contrastText: '#1E2A38',
    },
    error: {
      main: '#E63976', // Fuchsia Lumineux
    },
    background: {
      default: '#F8F4F1', // Beige Clair / Ivoire
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1E2A38',
      secondary: '#555555',
    },
  },
  typography: {
    fontFamily: '"Lato", "Arial", sans-serif',
    h1: {
      fontFamily: '"Tenor Sans", sans-serif',
      fontWeight: 400,
    },
    h2: {
      fontFamily: '"Tenor Sans", sans-serif',
      fontWeight: 400,
    },
    h3: {
      fontFamily: '"Tenor Sans", sans-serif',
      fontWeight: 400,
    },
    h4: {
      fontFamily: '"Tenor Sans", sans-serif',
      fontWeight: 400,
    },
    h5: {
      fontFamily: '"Tenor Sans", sans-serif',
      fontWeight: 400,
    },
    h6: {
      fontFamily: '"Tenor Sans", sans-serif',
      fontWeight: 400,
    },
    subtitle1: {
      fontFamily: '"Lato", sans-serif',
      fontWeight: 400,
    },
    subtitle2: {
      fontFamily: '"Lato", sans-serif',
      fontWeight: 400,
    },
    body1: {
      fontFamily: '"Lato", sans-serif',
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"Lato", sans-serif',
      fontWeight: 300,
    },
    button: {
      fontFamily: '"Lato", sans-serif',
      fontWeight: 700,
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: '12px 24px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  },
});

export default theme;
